import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Rights } from './models/enums/rights';
import { MemoryService } from './services/memory.service';

@Injectable({
    providedIn: 'root',
})
export class OrganizationSelectGuard {
    constructor(
        private memoryService: MemoryService,
        private router: Router
    ) {}

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const organizationIsSelect = this.memoryService.isOrganizationSelected();

        if (!organizationIsSelect && this.memoryService.getConnectedUser()) {
            if (
                this.memoryService
                    .getConnectedUser()
                    .hasSomeRight(
                        Rights.ArticleRead,
                        Rights.AttributRead,
                        Rights.BoxRead,
                        Rights.CustomerRead,
                        Rights.DocumentTypeRead,
                        Rights.EmailTemplateRead,
                        Rights.SmsTemplateRead,
                        Rights.FolderStateRead,
                        Rights.GroupAndUserRead,
                        Rights.ListLayoutRead,
                        Rights.OrganizationRead,
                        Rights.ParameterRead,
                        Rights.ProcessRead,
                        Rights.RoleRead,
                        Rights.WorkflowDefinitionRead
                    )
            ) {
                //this.memoryService.selectOrganization(this.memoryService.getConnectedUser().organization);
                //this.router.navigate(['/home']);
            } else {
                this.router.navigate(['/profile']);
            }
        }

        return organizationIsSelect;
    }
}
